"use strict";
/**
 * Strip out unneeded information relating to the database
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildDiscredentialRefined = void 0;
const buildDiscredentialRefined = ({ ID, matchingCriteria, metadata, program, type, origin, headings, subHeadings, }) => ({
    ID,
    matchingCriteria,
    metadata,
    program,
    type,
    origin,
    headings,
    subHeadings
});
exports.buildDiscredentialRefined = buildDiscredentialRefined;
//# sourceMappingURL=DiscredentialRefined.js.map